/**
 * 将Base64字符串转换为File对象
 *
 * @param {string} base64 - Base64格式的字符串，包含文件名信息
 * @returns {File} - 转换后的File对象
 */
export default function base64ToFile(base64) {
  // 分割Base64字符串，获取MIME类型、文件名和实际数据
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const nameMatch = arr[0].match(/name=(.*?);/);
  const filename = nameMatch ? nameMatch[1] : 'default-filename';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  // 将二进制字符串转换为Uint8Array
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  // 创建并返回File对象
  return new File([u8arr], filename, { type: mime });
}